import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  variant?: 'default' | 'elevated' | 'compact';
  className?: string;
}

export default function Card({ children, variant = 'default', className = '' }: CardProps) {
  const base = 'bg-card border-border rounded-2xl';
  const variants: Record<string, string> = {
    default: 'p-6 border-2',
    elevated: 'p-6 border-2 shadow-md',
    compact: 'p-4 border',
  };
  return <div className={`${base} ${variants[variant]} ${className}`}>{children}</div>;
}
